/// <amd-module name="Artifacts/Maven/commands/Badge" />
import { getBadgeCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createBadgeCommand = getBadgeCommandCreator();
